module.exports = __webpack_public_path__ + "img/colors.2b4087c4.svg";